import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import endpoints from "../../config/endpoints";
import { setLoading } from "../../services/reducers/homeSlice";
import restApi from "../../services/restApi";
import tools from "../../utils/tools";
import { Sidebar } from "../../layouts/Sidebar";

const PartManage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form, setForm] = useState<any>();
  const [categories, setCategories] = useState([]);
  const [selectedSpecifics, setSelectedSpecifics] = useState([]);
  const [specifics, setSpecifics] = useState([]);
  const { id: paramId } = useParams();

  const submit = async () => {
    dispatch(setLoading(true));

    const data: any = tools.extractor(form, [
      "title",
      "categoryId",
      "description",
      "oldId",
    ]);
    data.specifics = selectedSpecifics;

    const res = await restApi(endpoints.part.basic + (paramId || "")).post(
      data,
    );

    if (res.code == 200) {
      Swal.fire({
        title: "موفق",
        text: `نوع کالا با موفقیت ${paramId ? "ویرایش" : "اضافه"} شد`,
        icon: "success",
        confirmButtonText: "متوجه شدم",
        didClose() {
          navigate("/part/");
        },
      });
    } else {
      Swal.fire({
        title: "ناموفق",
        text: res?.data,
        icon: "error",
        confirmButtonText: "متوجه شدم",
      });
    }

    dispatch(setLoading(false));
  };

  const fetchData = async () => {
    dispatch(setLoading(true));

    const res = await Promise.all([
      restApi(endpoints.category.index).get({ type: "children" }),
      restApi(endpoints.specific.index).get(),
      paramId && restApi(endpoints.part.single + paramId).get(),
    ]);

    const sortedData = [];

    res[0].data.map((e) => tools.extractChildren(e, sortedData));

    setCategories(sortedData);
    setSpecifics(res[1].data);

    if (paramId) {
      setSelectedSpecifics(res[2].data?.specifics?.map((e) => e.id.toString()));

      setForm({
        title: res[2].data?.title,
        categoryId: res[2].data?.categoryId,
        description: res[2].data?.description,
        oldId: res[2].data?.oldId,
      });
    }

    dispatch(setLoading(false));
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <main className="dashboardBody">
        <Sidebar />
        <div className="dashBoardMain main">
          <div className="addInfoHeader">
            <div className="buttonContainer keepRight">
              <button
                className="dashboardHeader keepRight"
                onClick={() => submit()}
              >
                <p>{paramId ? "ویرایش" : "ایجاد"} نوع کالا</p>
              </button>
            </div>
            <span>
              <h1 className="sideBarTitle">بازگشت به صفحه نوع کالا</h1>
              <h1 className="dashBoardTitle">
                {paramId ? "ویرایش" : "ایجاد"} نوع کالا
              </h1>
            </span>
            <i className="backAdd" onClick={() => navigate("/part")}></i>
          </div>
          <section className="center">
            <div className="AddInfoContainer">
              <label>عنوان</label>
              <input
                className="persianName"
                defaultValue={form?.title}
                onChange={(input) =>
                  setForm((prev) => ({ ...prev, title: input.target.value }))
                }
              />
              <label>دسته بندی</label>
              <Select
                options={tools.selectFormatter(
                  categories,
                  "id",
                  "title",
                  "انتخاب کنید",
                )}
                value={{
                  value: form?.categoryId,
                  label: categories.find((e) => e.id == form?.categoryId)
                    ?.title,
                }}
                className="width100"
                id="infoTitle"
                onChange={(selected: any) =>
                  setForm((prev) => ({ ...prev, categoryId: selected.value }))
                }
              />
              <label>نوع کالا قدیمی (old Id)</label>
              <label>مشخصات فنی</label>
              <Select
                options={tools.selectFormatter(
                  specifics.sort(
                    (a, b) =>
                      b?.title?.includes(form?.title) -
                      a?.title?.includes(form?.title),
                  ),
                  "id",
                  "title",
                  "انتخاب کنید",
                )}
                value={tools.selectFormatter(
                  specifics.filter((e) =>
                    selectedSpecifics.includes(e.id.toString()),
                  ),
                  "id",
                  "title",
                )}
                isMulti={true}
                className="width100"
                id="infoTitle"
                onChange={(selected: any) =>
                  setSelectedSpecifics((prev) =>
                    selected.map((e) => e.value.toString()),
                  )
                }
              />
              <label>توضیحات</label>
              <textarea
                className="ShortDiscription"
                defaultValue={form?.description}
                onChange={(input) =>
                  setForm((prev) => ({
                    ...prev,
                    description: input.target.value,
                  }))
                }
              />
            </div>
          </section>
        </div>
      </main>
    </>
  );
};

export default PartManage;
